import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ff0005ee")

_pushScopeId("data-v-ff0005ee")
const _hoisted_1 = { class: "performanceOverview" }
const _hoisted_2 = { class: "displayIndicators" }
const _hoisted_3 = { class: "dialog-footer" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 确认 ")
const _hoisted_6 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("自动化任务时间轴")
], -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_8 = { class: "titleTime-container" }
const _hoisted_9 = { style: {"cursor":"pointer"} }
const _hoisted_10 = { style: {"padding":"0 40px"} }
const _hoisted_11 = { class: "canvs" }
const _hoisted_12 = /*#__PURE__*/_createVNode("span", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("span", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("性能概况")
], -1)
const _hoisted_16 = { class: "spacName" }
const _hoisted_17 = { style: {"display":"flex","align-items":"center","margin-bottom":"20px"} }
const _hoisted_18 = { class: "block" }
const _hoisted_19 = { style: {"margin-bottom":"20px"} }
const _hoisted_20 = {
  class: "all_echarts",
  sytle: "display:flex;backgrond:#f00"
}
const _hoisted_21 = { class: "performanceDataDetails" }
const _hoisted_22 = { class: "TitleStyle" }
const _hoisted_23 = /*#__PURE__*/_createVNode("span", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode("最近测试记录    ")
const _hoisted_25 = { class: "spacName2" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("全部清空")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("查看")
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "dialogForm" }
const _hoisted_30 = { class: "dialogTitle" }
const _hoisted_31 = /*#__PURE__*/_createVNode("span", null, "上传性能数据", -1)
const _hoisted_32 = /*#__PURE__*/_createVNode("i", { class: "el-icon-upload" }, null, -1)
const _hoisted_33 = /*#__PURE__*/_createVNode("div", { class: "el-upload__text" }, [
  /*#__PURE__*/_createTextVNode(" 将文件拖到此处，或 "),
  /*#__PURE__*/_createVNode("em", null, "点击上传")
], -1)
const _hoisted_34 = /*#__PURE__*/_createVNode("div", { class: "el-upload__tip" }, " 只能上传excel文件，且不超过50MB ", -1)
const _hoisted_35 = { class: "dialog-footer" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode("重 置")
const _hoisted_37 = /*#__PURE__*/_createTextVNode("确 定")
const _hoisted_38 = { class: "dialogForm" }
const _hoisted_39 = { class: "dialogTitle" }
const _hoisted_40 = /*#__PURE__*/_createVNode("span", null, "上传性能数据(runmax)", -1)
const _hoisted_41 = /*#__PURE__*/_createVNode("i", { class: "el-icon-upload" }, null, -1)
const _hoisted_42 = /*#__PURE__*/_createVNode("div", { class: "el-upload__text" }, [
  /*#__PURE__*/_createTextVNode(" 将文件拖到此处，或 "),
  /*#__PURE__*/_createVNode("em", null, "点击上传")
], -1)
const _hoisted_43 = /*#__PURE__*/_createVNode("div", { class: "el-upload__tip" }, " 只能上传csv文件，且不超过50MB ", -1)
const _hoisted_44 = { class: "dialog-footer" }
const _hoisted_45 = /*#__PURE__*/_createTextVNode("重 置")
const _hoisted_46 = /*#__PURE__*/_createTextVNode("确 定")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")
  const _component_el_option_group = _resolveComponent("el-option-group")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_link = _resolveComponent("el-link")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_tabs = _resolveComponent("el-tabs")
  const _component_el_divider = _resolveComponent("el-divider")
  const _component_el_upload = _resolveComponent("el-upload")
  const _component_el_space = _resolveComponent("el-space")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode(_component_el_tabs, {
                  onTabClick: _ctx.tabsChange,
                  type: "card",
                  modelValue: _ctx.activeName,
                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (_ctx.activeName = $event))
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_tab_pane, {
                      name: "first",
                      label: "自动化性能概况"
                    }, {
                      default: _withId(() => [
                        _createVNode("div", _hoisted_2, [
                          _createVNode(_component_el_dialog, {
                            width: "500px",
                            modelValue: _ctx.dialogTableVisible,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.dialogTableVisible = $event)),
                            title: "提示"
                          }, {
                            footer: _withId(() => [
                              _createVNode("span", _hoisted_3, [
                                _createVNode(_component_el_button, {
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dialogTableVisible = false))
                                }, {
                                  default: _withId(() => [
                                    _hoisted_4
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.labelBtn()))
                                }, {
                                  default: _withId(() => [
                                    _hoisted_5
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            default: _withId(() => [
                              _createVNode(_component_el_form, {
                                inline: true,
                                size: "mini"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_form_item, { label: "输入标记内容" }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: _ctx.label_input,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.label_input = $event))
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _withDirectives(_createVNode("span", null, _toDisplayString(_ctx.c(_ctx.searchVal)), 513), [
                            [_vShow, false]
                          ]),
                          _hoisted_6,
                          _hoisted_7,
                          _createVNode(_component_el_card, null, {
                            default: _withId(() => [
                              _createVNode("div", _hoisted_8, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.automated_task_timeline, (item) => {
                                  return (_openBlock(), _createBlock("div", {
                                    class: "titleTime",
                                    key: item.id
                                  }, [
                                    _createVNode("a", _hoisted_9, [
                                      _createVNode("div", _hoisted_10, [
                                        _createVNode("p", null, _toDisplayString(item.task_name), 1),
                                        _createVNode("p", null, _toDisplayString(item.game_version === null
                                ? "--"
                                : item.game_version), 1),
                                        _createVNode("p", null, _toDisplayString(item.start_date), 1)
                                      ]),
                                      _createVNode("p", _hoisted_11, [
                                        _hoisted_12,
                                        _createVNode("span", {
                                          class: 
                              item.status == '完成' ? 'complete' : 'cancel'
                            
                                        }, null, 2),
                                        _hoisted_13
                                      ])
                                    ])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _hoisted_14,
                        _createVNode("div", null, [
                          _hoisted_15,
                          _createVNode("div", _hoisted_16, [
                            _createVNode("div", _hoisted_17, [
                              _createVNode(_component_el_form, {
                                class: "formMap",
                                inline: true,
                                size: "mini",
                                model: _ctx.choice
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_form_item, { label: "场景" }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_select, {
                                        modelValue: _ctx.choice.scene,
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.choice.scene = $event)),
                                        onChange: _ctx.selectSceneChange,
                                        placeholder: ""
                                      }, {
                                        default: _withId(() => [
                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.performace_select_options.scene_list, (item) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: item.scene_id,
                                              label: item.chinese,
                                              value: item.scene_id
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue", "onChange"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_form_item, { label: "平台" }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_select, {
                                        modelValue: _ctx.platform,
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.platform = $event)),
                                        onChange: _ctx.selectSceneChange,
                                        placeholder: ""
                                      }, {
                                        default: _withId(() => [
                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.platformArr, (item) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: item.value,
                                              label: item.label,
                                              value: item.value
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue", "onChange"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["model"]),
                              _createVNode("div", _hoisted_18, [
                                _createVNode(_component_el_date_picker, {
                                  modelValue: _ctx.valueTime,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.valueTime = $event)),
                                  type: "daterange",
                                  "range-separator": "To",
                                  "start-placeholder": "开始日期",
                                  "end-placeholder": "结束日期",
                                  onChange: _ctx.timeChange,
                                  "default-value": _ctx.timeDefaultShow
                                }, null, 8, ["modelValue", "onChange", "default-value"])
                              ])
                            ]),
                            _createVNode("div", _hoisted_19, [
                              _createVNode(_component_el_form, {
                                class: "formMap",
                                inline: true,
                                size: "mini",
                                model: _ctx.typeForm
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_form_item, { label: "测试类型" }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_select, {
                                        modelValue: _ctx.typeForm.faType,
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.typeForm.faType = $event)),
                                        onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.selectSceneChange(true))),
                                        placeholder: "默认选择Android"
                                      }, {
                                        default: _withId(() => [
                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.typefaList, (item) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: item.value,
                                              label: item.name,
                                              value: item.value
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_form_item, { label: "子类型" }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_select, {
                                        modelValue: _ctx.typeForm.sonType,
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.typeForm.sonType = $event)),
                                        onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.selectSceneChange(false))),
                                        placeholder: "默认选择Android"
                                      }, {
                                        default: _withId(() => [
                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sonList, (item) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: item.value,
                                              label: item.name,
                                              value: item.value
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["model"])
                            ]),
                            _createVNode("div", _hoisted_20, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.target_side_by_side1, (item) => {
                                return (_openBlock(), _createBlock("div", {
                                  class: "all_echarts_box",
                                  style: {"width":"49%","height":"490px","margin":"0, 0.5%, 20px, 0"},
                                  key: item
                                }, [
                                  _withDirectives(_createVNode(_component_el_card, null, {
                                    default: _withId(() => [
                                      _createVNode("div", {
                                        id: 'performance_trend_' + item,
                                        class: "echartHeight"
                                      }, null, 8, ["id"])
                                    ]),
                                    _: 2
                                  }, 1536), [
                                    [_directive_loading, _ctx.line_loading]
                                  ])
                                ]))
                              }), 128))
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_tab_pane, {
                      name: "second",
                      label: "自动化测试数据"
                    }, {
                      default: _withId(() => [
                        _createVNode("div", _hoisted_21, [
                          _createVNode("h5", _hoisted_22, [
                            _hoisted_23,
                            _hoisted_24,
                            _createVNode("i", {
                              style: _ctx.get_is_super ? 'visibility: hidden' : '',
                              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.submitUpload('open')))
                            }, "上传性能数据 ", 4),
                            false
                              ? (_openBlock(), _createBlock("i", {
                                  key: 0,
                                  style: _ctx.get_is_super ? 'visibility: hidden' : '',
                                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.UploadRunmax('open')))
                                }, " 上传性能数据(runmax)", 4))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode("div", _hoisted_25, [
                            _createVNode(_component_el_card, null, {
                              default: _withId(() => [
                                _createVNode(_component_el_form, {
                                  class: "spacForm",
                                  size: "mini",
                                  inline: true
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_form_item, { label: "选择场景" }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_select, {
                                          modelValue: _ctx.selected_table_scene,
                                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.selected_table_scene = $event)),
                                          placeholder: "请选择场景",
                                          clearable: "",
                                          filterable: "",
                                          onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.selectTableChange('Search')))
                                        }, {
                                          default: _withId(() => [
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.scene_options, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item.scene_id,
                                                label: item.chinese,
                                                value: item.scene_id
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, { label: "选择机型" }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_select, {
                                          modelValue: _ctx.selected_table_device,
                                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.selected_table_device = $event)),
                                          placeholder: "请选择机型",
                                          clearable: "",
                                          filterable: "",
                                          onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.selectTableChange('Search')))
                                        }, {
                                          default: _withId(() => [
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.device_options, (group) => {
                                              return (_openBlock(), _createBlock(_component_el_option_group, {
                                                key: group.label,
                                                label: group.label
                                              }, {
                                                default: _withId(() => [
                                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(group.data, (item) => {
                                                    return (_openBlock(), _createBlock(_component_el_option, {
                                                      key: item.value,
                                                      label: item.label,
                                                      value: item.value
                                                    }, null, 8, ["label", "value"]))
                                                  }), 128))
                                                ]),
                                                _: 2
                                              }, 1032, ["label"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, { label: "选择版本" }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_select, {
                                          modelValue: _ctx.selected_table_version,
                                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.selected_table_version = $event)),
                                          placeholder: "请选择版本",
                                          clearable: "",
                                          filterable: "",
                                          onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.selectTableChange('Search')))
                                        }, {
                                          default: _withId(() => [
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.game_version_options, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item.value,
                                                label: item.label,
                                                value: item.value
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, { label: "选择发布版本" }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_select, {
                                          modelValue: _ctx.custom,
                                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.custom = $event)),
                                          placeholder: "请选择发布版本",
                                          multiple: "",
                                          "collapse-tags": "",
                                          "collapse-tags-tooltip": "",
                                          onChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.selectTableChange('Search')))
                                        }, {
                                          default: _withId(() => [
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.customVersion_options, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item,
                                                label: item,
                                                value: item
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, { label: "是否有效" }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_select, {
                                          modelValue: _ctx.selected_table_judge,
                                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.selected_table_judge = $event)),
                                          placeholder: "请选择版本",
                                          clearable: "",
                                          onChange: _cache[23] || (_cache[23] = ($event: any) => (_ctx.selectTableChange('Search')))
                                        }, {
                                          default: _withId(() => [
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.judge, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item.value,
                                                label: item.label,
                                                value: item.value
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, { label: "record_id" }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_input, {
                                          class: "input",
                                          onBlur: _cache[24] || (_cache[24] = ($event: any) => (_ctx.blurUsername('Search'))),
                                          modelValue: _ctx.indexValue,
                                          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.indexValue = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, null, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_button, {
                                          type: "primary",
                                          onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.onTableClear()))
                                        }, {
                                          default: _withId(() => [
                                            _hoisted_26
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _withDirectives(_createVNode(_component_el_table, {
                                  data: _ctx.get_all_performance,
                                  ref: "dataTable",
                                  "header-cell-class-name": "tabelHeader"
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_table_column, {
                                      index: _ctx.indexMethod(0),
                                      type: "index",
                                      label: "序号",
                                      width: "60"
                                    }, null, 8, ["index"]),
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.PerfFields, (item, index) => {
                                      return (_openBlock(), _createBlock(_component_el_table_column, {
                                        key: item.label,
                                        index: index,
                                        width: item.width,
                                        label: item.label,
                                        prop: item.prop,
                                        title: item.prop,
                                        "show-overflow-tooltip": true
                                      }, null, 8, ["index", "width", "label", "prop", "title"]))
                                    }), 128)),
                                    _createVNode(_component_el_table_column, {
                                      label: "有效",
                                      width: "60",
                                      fixed: "right"
                                    }, {
                                      header: _withId(() => [
                                        _createVNode(_component_el_checkbox, {
                                          modelValue: _ctx.is_valid,
                                          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.is_valid = $event)),
                                          disabled: _ctx.get_is_super,
                                          onChange: _ctx.handleSelect
                                        }, null, 8, ["modelValue", "disabled", "onChange"])
                                      ]),
                                      default: _withId((scope) => [
                                        _createVNode(_component_el_tooltip, {
                                          effect: "dark",
                                          disabled: !_ctx.get_is_super,
                                          content: "暂无管理员权限",
                                          placement: "top"
                                        }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_checkbox, {
                                              modelValue: scope.row.is_valid,
                                              "onUpdate:modelValue": ($event: any) => (scope.row.is_valid = $event),
                                              disabled: _ctx.get_is_super,
                                              onChange: ($event: any) => (_ctx.IsValidChange(scope.row))
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onChange"])
                                          ]),
                                          _: 2
                                        }, 1032, ["disabled"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      label: "详情",
                                      width: "60",
                                      fixed: "right"
                                    }, {
                                      default: _withId((scope) => [
                                        (scope.row.url)
                                          ? (_openBlock(), _createBlock(_component_el_link, {
                                              key: 0,
                                              href: _ctx.get_url(scope.row.url),
                                              type: "primary",
                                              target: "_blank"
                                            }, {
                                              default: _withId(() => [
                                                _hoisted_27
                                              ]),
                                              _: 2
                                            }, 1032, ["href"]))
                                          : (_openBlock(), _createBlock("span", _hoisted_28, "-"))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["data"]), [
                                  [_directive_loading, _ctx.loading]
                                ]),
                                _createVNode(_component_el_form, {
                                  inline: true,
                                  size: "mini",
                                  class: "pagingStyle"
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_form_item, { label: "每页" }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.record,
                                          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.record = $event)),
                                          style: {"width":"50px"},
                                          onChange: _cache[29] || (_cache[29] = ($event: any) => (_ctx.selectTableChange('paging')))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, { label: "条记录" }),
                                    _createVNode(_component_el_form_item, null, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_pagination, {
                                          onCurrentChange: _cache[30] || (_cache[30] = ($event: any) => (_ctx.selectTableChange('paging'))),
                                          currentPage: _ctx.current_page,
                                          "onUpdate:currentPage": _cache[31] || (_cache[31] = ($event: any) => (_ctx.current_page = $event)),
                                          "page-size": _ctx.record,
                                          layout: "total, prev, pager, next, jumper",
                                          total: _ctx.readPerformancePageList.count
                                        }, null, 8, ["currentPage", "page-size", "total"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["onTabClick", "modelValue"]),
                _createVNode("div", _hoisted_29, [
                  _createVNode(_component_el_dialog, {
                    modelValue: _ctx.dialogVisible,
                    "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => (_ctx.dialogVisible = $event)),
                    width: "30%",
                    onClose: _cache[44] || (_cache[44] = ($event: any) => (_ctx.dialogVisible = false))
                  }, {
                    title: _withId(() => [
                      _createVNode("div", _hoisted_30, [
                        _hoisted_31,
                        _createVNode(_component_el_divider)
                      ])
                    ]),
                    footer: _withId(() => [
                      _createVNode("span", _hoisted_35, [
                        _createVNode(_component_el_button, {
                          size: "small",
                          onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.submitUpload('no')))
                        }, {
                          default: _withId(() => [
                            _hoisted_36
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_button, {
                          size: "small",
                          type: "primary",
                          onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.submitUpload('ok')))
                        }, {
                          default: _withId(() => [
                            _hoisted_37
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    default: _withId(() => [
                      _createVNode(_component_el_form, {
                        inline: true,
                        model: _ctx.dialogForm,
                        size: "small",
                        "label-position": "top"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "地图" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.dialogForm.scene_id,
                                "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (_ctx.dialogForm.scene_id = $event)),
                                placeholder: "请选择地图",
                                filterable: ""
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getScenes, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.id,
                                      label: item.chinese,
                                      value: item.id
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "设备" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.dialogForm.UUID,
                                "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (_ctx.dialogForm.UUID = $event)),
                                filterable: "",
                                placeholder: "请选择设备"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.DeviceSpecs, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: index,
                                      label: 
                        item.model.name +
                        ' (' +
                        item.model.model +
                        ') - ' +
                        item.UUID
                      ,
                                      value: item.UUID,
                                      title: 
                        item.model.name +
                        ' (' +
                        item.model.model +
                        ') - ' +
                        item.UUID
                      
                                    }, null, 8, ["label", "value", "title"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "场景脚本" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                filterable: "",
                                modelValue: _ctx.dialogForm.script_id,
                                "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (_ctx.dialogForm.script_id = $event)),
                                placeholder: "请选择场景脚本"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getScripts(_ctx.dialogForm.scene_id), (script) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: script.script_id,
                                      label: script.script_name,
                                      value: script.script_id
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            label: "数据是否有效",
                            align: "center"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_checkbox, {
                                modelValue: _ctx.dialogForm.is_valid,
                                "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (_ctx.dialogForm.is_valid = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            label: "数据是否为自动采集",
                            align: "center"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_checkbox, {
                                modelValue: _ctx.dialogForm.b_auto_collect,
                                "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (_ctx.dialogForm.b_auto_collect = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["model"]),
                      _createVNode(_component_el_form, {
                        model: _ctx.dialogForm,
                        size: "small",
                        "label-position": "top"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "上传文件" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_upload, {
                                class: "upload-demo",
                                drag: "",
                                action: "http://127.0.0.1:8081/api/v1/performance/dfm_ios_perdog_upload/",
                                multiple: "",
                                limit: 1,
                                "before-upload": _ctx.beforeUpload,
                                ref: 'upload',
                                "http-request": _ctx.UploadFile
                              }, {
                                tip: _withId(() => [
                                  _hoisted_34
                                ]),
                                default: _withId(() => [
                                  _hoisted_32,
                                  _hoisted_33
                                ]),
                                _: 1
                              }, 8, ["before-upload", "http-request"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_space, { size: 150 }, {
                            default: _withId(() => [
                              _createVNode(_component_el_form_item, {
                                label: "任务记录",
                                align: "center"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_input, {
                                    style: {"width":"150px"},
                                    modelValue: _ctx.dialogForm.task_record_id,
                                    "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => (_ctx.dialogForm.task_record_id = $event)),
                                    placeholder: "请输入任务记录id..."
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, { label: "任务组索引" }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_input, {
                                    style: {"width":"150px"},
                                    modelValue: _ctx.dialogForm.task_group_index,
                                    "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => (_ctx.dialogForm.task_group_index = $event)),
                                    placeholder: "请输入索引..."
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "备注" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_input, {
                                type: "textarea",
                                modelValue: _ctx.dialogForm.remark,
                                "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => (_ctx.dialogForm.remark = $event)),
                                placeholder: "请输入备注..."
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["model"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createVNode("div", _hoisted_38, [
                  _createVNode(_component_el_dialog, {
                    modelValue: _ctx.dialogVisibleRunmax,
                    "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => (_ctx.dialogVisibleRunmax = $event)),
                    width: "30%",
                    onClose: _cache[53] || (_cache[53] = ($event: any) => (_ctx.dialogVisibleRunmax = false))
                  }, {
                    title: _withId(() => [
                      _createVNode("div", _hoisted_39, [
                        _hoisted_40,
                        _createVNode(_component_el_divider)
                      ])
                    ]),
                    footer: _withId(() => [
                      _createVNode("span", _hoisted_44, [
                        _createVNode(_component_el_button, {
                          size: "small",
                          onClick: _cache[50] || (_cache[50] = ($event: any) => (_ctx.UploadRunmax('no')))
                        }, {
                          default: _withId(() => [
                            _hoisted_45
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_button, {
                          size: "small",
                          type: "primary",
                          onClick: _cache[51] || (_cache[51] = ($event: any) => (_ctx.UploadRunmax('ok')))
                        }, {
                          default: _withId(() => [
                            _hoisted_46
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    default: _withId(() => [
                      _createVNode(_component_el_form, {
                        inline: true,
                        model: _ctx.dialogRunmaxForm,
                        size: "small",
                        "label-position": "top"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_space, { size: 150 }, {
                            default: _withId(() => [
                              _createVNode(_component_el_form_item, {
                                label: "任务记录",
                                align: "center"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_input, {
                                    style: {"width":"150px"},
                                    modelValue: _ctx.dialogRunmaxForm.task_record_id,
                                    "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => (_ctx.dialogRunmaxForm.task_record_id = $event)),
                                    placeholder: "请输入任务记录id..."
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, { label: "任务组索引" }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_input, {
                                    style: {"width":"150px"},
                                    modelValue: _ctx.dialogRunmaxForm.task_group_index,
                                    "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => (_ctx.dialogRunmaxForm.task_group_index = $event)),
                                    placeholder: "请输入索引..."
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "设备" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.dialogRunmaxForm.UUID,
                                "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => (_ctx.dialogRunmaxForm.UUID = $event)),
                                placeholder: "请选择设备",
                                style: {"width":"150px"}
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.DeviceSpecs, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: index,
                                      label: item.model.name + ' (' + item.model.model + ')',
                                      value: item.UUID,
                                      title: item.model.name + ' (' + item.model.model + ')'
                                    }, null, 8, ["label", "value", "title"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "地图" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.dialogRunmaxForm.scene_id,
                                "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => (_ctx.dialogRunmaxForm.scene_id = $event)),
                                placeholder: "请选择地图",
                                style: {"width":"150px"}
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getScenes, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.id,
                                      label: item.chinese,
                                      value: item.id
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "场景脚本" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.dialogRunmaxForm.script_id,
                                "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => (_ctx.dialogRunmaxForm.script_id = $event)),
                                placeholder: "请选择场景脚本",
                                style: {"width":"150px"}
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getScripts(_ctx.dialogRunmaxForm.scene_id), (script) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: script.script_id,
                                      label: script.script_name,
                                      value: script.script_id
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["model"]),
                      _createVNode(_component_el_form, {
                        model: _ctx.dialogRunmaxForm,
                        size: "small",
                        "label-position": "top"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "上传文件" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_upload, {
                                class: "upload-demo",
                                drag: "",
                                action: "http://127.0.0.1:8081/api/v1/performance/performance_upload_all/",
                                multiple: "",
                                limit: 1,
                                "before-upload": _ctx.beforeUploadRunmax,
                                ref: 'upload_runmax',
                                "http-request": _ctx.UploadRunmaxFile
                              }, {
                                tip: _withId(() => [
                                  _hoisted_43
                                ]),
                                default: _withId(() => [
                                  _hoisted_41,
                                  _hoisted_42
                                ]),
                                _: 1
                              }, 8, ["before-upload", "http-request"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["model"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})